import dayjs from "dayjs";
import "dayjs/locale/es.js";
import dayOfYear from "dayjs/plugin/dayOfYear.js";

dayjs.locale("es");
dayjs.extend(dayOfYear);

// Helpers de fecha de la app. Funciones puras (sin AppConfig) para poder testearlas con node --test.
export const Fechas = {
  /** "12/10/2026" */
  formatear(fecha) {
    return dayjs(fecha).format("DD/MM/YYYY");
  },

  /** "12 de octubre" */
  formatearLargo(fecha) {
    return dayjs(fecha).format("D [de] MMMM");
  },

  /** Dias corridos entre dos fechas, ambas inclusive (mismo criterio que Vacacion.Dias en el backend). */
  diasCorridos(desde, hasta) {
    return dayjs(hasta).startOf("day").diff(dayjs(desde).startOf("day"), "day") + 1;
  },

  sumarDias(fecha, dias) {
    return dayjs(fecha).add(dias, "day").toDate();
  },

  /** Lo que espera el backend en Desde/Hasta: fecha a las 09:00Z para que no cambie de dia por zona horaria. */
  aIsoApi(fecha) {
    return dayjs(fecha).format("YYYY-MM-DD") + "T09:00:00.000Z";
  },

  /** Imagen del boton "Nuevas vacaciones" segun la estacion (dia del anio). */
  imagenTemporada(fecha = new Date()) {
    const dia = dayjs(fecha).dayOfYear();
    if (dia > 355) return "v.jpg";
    if (dia > 264) return "p.jpg";
    if (dia > 172) return "i.jpg";
    if (dia > 80) return "o.jpg";
    return "v.jpg";
  },
};
